import { Box, Button, TextInput } from "@mantine/core";
import { useForm } from "@mantine/form";

export function SiteForm(params: {
  name: string;
  onSubmit?: (values: any) => void;
}) {
  const { name, onSubmit } = params;
  const form = useForm({
    initialValues: {
      terms: false,
      name: name,
    },
  });

  return (
    <Box maw={320} mx="auto">
      <form onSubmit={form.onSubmit((values) => onSubmit && onSubmit(values))}>
        <TextInput
          label="사업장코드"
          withAsterisk
          {...form.getInputProps("code")}
        />
        <TextInput
          label="사업장명"
          withAsterisk
          {...form.getInputProps("name")}
        />
        <Button type="submit">Submit</Button>
      </form>
    </Box>
  );
}
